import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { connectLean } from 'lean-redux';
import Button from 'chameleon/ui-stack/ui/base/button';
import AlertMessage from './AlertMessage';
/**
 * Draws save button
 * */
const ActionButtons = (props) => {
  const {
    hasAlert,
    selectedItems,
    savedClasses,
    onSave,
    onCancel,
    saveButtonText,
    className,
  } = props;
  const [isFormDirty, setIsFormDirty] = useState(false);
  const [stringifiedSavedClasses, setStringifiedSavedClasses] = useState(
    savedClasses.sort().toString(),
  );
  const [stringifiedSelectedItems, setStringifiedSelectedItems] = useState(
    selectedItems.sort().toString(),
  );

  useEffect(() => {
    setStringifiedSavedClasses(savedClasses.sort().toString());
  }, [savedClasses]);

  useEffect(() => {
    setStringifiedSelectedItems(selectedItems.sort().toString());
  }, [selectedItems]);

  useEffect(() => {
    setIsFormDirty(stringifiedSelectedItems !== stringifiedSavedClasses);
  }, [stringifiedSelectedItems]);

  /**
   * On save button click handler
   * @note uses saveClick callback to save selected items
   * */
  const onSaveClick = () => {
    onSave(selectedItems, savedClasses);
  };

  /**
   * On cancel button click handler
   * */
  const onCancelClick = () => {
    onCancel();
  };

  return (
    <Fragment>
      <div
        className={cn({
          hidden: !hasAlert || !isFormDirty || selectedItems.length,
        })}
      >
        <AlertMessage show />
      </div>
      <div className={`ConfirmationButtons action-buttons ${className}`}>
        <Button
          isPrimary
          disabled={!isFormDirty}
          onClick={onSaveClick}
          style={{ marginLeft: '10px' }}
        >
          {saveButtonText || 'Save'}
        </Button>
        <Button isNaked onClick={onCancelClick}>
          Cancel
        </Button>
      </div>
    </Fragment>
  );
};

ActionButtons.displayName = 'ActionButtons';

ActionButtons.propTypes = {
  selectedItems: PropTypes.array,
  hasAlert: PropTypes.bool,
  savedClasses: PropTypes.array,
  onSave: PropTypes.func,
  onCancel: PropTypes.func,
  className: PropTypes.string,
};

ActionButtons.defaultProps = {
  selectedItems: [],
  savedClasses: [],
  hasAlert: false,
  onSave: () => {},
  onCancel: () => {},
  className: '',
};

export default connectLean({
  getInitialState() {
    return {
      selectedItems: [],
      savedClasses: [],
    };
  },
  mapState(state) {
    const { selectedItems, savedClasses } = state;

    return {
      selectedItems,
      savedClasses,
    };
  },
})(ActionButtons);
